// extracted by mini-css-extract-plugin
export default {"grid":"ProductGrid_grid__j-Neq","paginationContainer":"ProductGrid_paginationContainer__WWYaK"};